import BaseApi from '../base';
import ApiError from '@/errors/api';

class CheckupApi extends BaseApi {
  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getCatalogs(token) {
    return this.makeRequest(this.METHOD_GET, 'catalogs', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getItems(token) {
    return this.makeRequest(this.METHOD_GET, 'items', token);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @returns {Promise<*>}
   */
  async getPrescriptions(token, id) {
    return this.makeRequest(this.METHOD_GET, `prescriptions?user=${id}`, token);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @returns {Promise<*>}
   */
  async getAnswers(token, id) {
    return this.makeRequest(this.METHOD_GET, `answers?user=${id}`, token);
  }

  /**
   * @param {Response} response
   */
  parseResponse(response) {
    if (typeof response.data === 'undefined') {
      throw new ApiError('Invalid response', this.ERROR_CODE);
    }

    return response.data;
  }
}

export default CheckupApi;
